import {SelectedPlayers} from "./SelectedPlayers"
import {CostDisplay} from "./CostDisplay"

export const TeamDisplay = ({team, setTeam}) => {

    return (
        <div>
            <SelectedPlayers team={team} setTeam={setTeam} />
            <CostDisplay team={team} />
        </div>
    )
}